<button class="mat-flat-button button" (click)="onClick()">
  <span class="mx-auto" [innerHTML]="linkTotext | safeHtml"></span>
</button>